import './assets/scss/index.scss'
